<template>
  <v-card tile>
    <v-toolbar card dark color="primary">
      <v-btn icon @click.native='close' dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Edit Attendee</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click.native="save">Save</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-layout row ma-2>
        <v-flex xs4>
          <v-card ma-2 class="elevation-4">
            <v-layout  ma-2 row wrap left-space-around>
              <v-flex xs8>
                <h3>Personal Information</h3>
                <content-field
                  v-model="traderForm.firstName"
                  :error="$v.traderForm.firstName"
                  label="First Name"/>
                <content-field
                  v-model="traderForm.lastName"
                  :error="$v.traderForm.lastName"
                  label="Last Name"/>
                <content-field
                  label="Email"
                  :error="$v.traderForm.email"
                  v-model="traderForm.email"/>
                <content-field
                  label="Phone number"
                  :error="$v.traderForm.phoneNumber"
                  v-model="traderForm.phoneNumber"/>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs6 class="ml-5">
          <v-card ma-2 class="elevation-4">
            <v-layout  ma-2 row wrap left-space-around>
              <v-flex xs12>
                <h3>Additional Information</h3>
                <v-layout row wrap justify-space-between>
                  <v-flex xs3>
                    <content-field
                      solo
                      v-model="traderForm.registrationStatus"
                      readonly
                      label="Status"/>
                  </v-flex>
                  <v-flex xs3>
                    <content-field
                      v-model="traderForm.uniqueId"
                      solo
                      readonly
                      label="Unique id"/>
                  </v-flex>
                  <v-flex xs3>
                    <content-field
                      :value="traderForm.registrationIp || 'None'"
                      solo
                      readonly
                      label="IP Address"/>
                  </v-flex>

                </v-layout>
                <v-layout row wrap justify-space-between
                v-if="isRegistrationStatusCompleted">
                    <v-flex xs5>
                    <content-field
                    solo
                    v-model="traderCreationDate"
                    readonly
                    label="Creation Date"/>
                    </v-flex>
                </v-layout>
                <v-layout row wrap justify-space-between>
                  <v-select
                    :items="attendeeTypesList"
                    v-model="traderForm.attendeeTypeId"
                    item-value="id"
                    item-text="title"
                    label="Attendee Types">
                  </v-select>
                </v-layout>
                <v-layout row wrap justify-space-between>
                  <content-field
                    v-model="traderForm.cid"
                    label="CID"/>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        </v-layout>
        <v-layout row ma-2>
          <v-flex xs4>
            <v-card ma-2 class="elevation-4">
              <v-layout  ma-2 row wrap left-space-around>
                <v-flex ma-3 v-if="isRegistrationStatusCompleted" xs5>
                  <h3>Predefined activities </h3>
                  {{traderForm.package.predefinedActivity}}
                  <v-layout row wrap>
                    <v-flex xs12 class="my-4">
                      <div v-for="(value) in predefinedActivity" :key="`predefined-activity-${value.id}`">
                        <v-checkbox
                          v-model="traderForm.package.predefinedActivities"
                          :label="`${value.title}`"
                          :value="value.id"
                        />
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex ma-3 xs12>
                  <h3>Newsletter Subscription</h3>
                  <v-layout column wrap>
                    <v-flex mt-4>
                      <v-checkbox
                        v-model="traderForm.subscribeToProvidersOffers"
                        label="Subscribe to Providers Offers"/>
                    </v-flex>
                    <v-flex>
                      <v-checkbox
                        v-model="traderForm.subscribeToEventsInfo"
                        label="Subscribe to Events info"/>
                    </v-flex>
                    <v-flex>
                      <v-checkbox
                        v-model="traderForm.subscribeToDailyNews"
                        label="Subscribe to Daily News"/>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs6 class="ml-5">
            <v-card ma-2 class="elevation-4" v-if="isPendingPackageSelectionStatus">
              <v-flex pa-3>
                <h3>Package isn't chosen yet. Assign package manually: </h3>
                <v-layout column>
                  <v-flex xs12 v-if="packagesList">
                    <v-select
                      :items="cryptoTraderPackagesList"
                      v-model="assignedPackageId"
                      item-value="id"
                      item-text="name"
                      label="Assign package">
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card>
            <v-card ma-2 class="elevation-4" v-if="isPackageData">
              <v-flex pa-3>
                <h3>Package Information</h3>
                <v-layout row wrap justify-space-between>
                  <v-flex xs5>
                    <content-field
                      readonly
                      v-model="traderForm.package.name"
                      label="Name"/>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-space-between>
                  <v-flex xs5>
                    <content-field
                      readonly
                      v-model="traderForm.package.type"
                      label="Type"/>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-space-between>
                  <v-flex xs5>
                    <content-field
                      readonly
                      v-model="traderForm.package.creationDate"
                      label="Creation Date"/>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-space-between>
                  <v-flex xs5>
                    <content-field
                      readonly
                      v-model="traderForm.package.title"
                      label="Title"/>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 pa-3 v-if="packagesList">
                <h4>Choose different package:</h4>
                <v-switch
                  label="Change package"
                  v-model="isPackageChanged"
                />
                <v-select
                  v-if="isPackageChanged"
                  :items="cryptoTraderPackagesList"
                  v-model="newChosenPackageId"
                  item-value="id"
                  item-text="name"
                  label="Packages list">
                </v-select>
              </v-flex>
              <v-flex xs12 pa-3
                v-if="formAttendee.affiliateImageUrl && formAttendee.affiliateImageUrl.length"
              >
                <h4>Affiliate:</h4>
                <a
                  target="_blank"
                  class="wordBreak"
                  :href="formAttendee.affiliateImageUrl"
                >
                  Download Affiliate Image
                </a>
              </v-flex>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import ContentField from '@/components/shared/ContentField/index.vue'
import {clone, isNil, path} from 'ramda'
import { required, email } from 'vuelidate/lib/validators'
import phoneNumberValidation from '@/utils/validators/isPhoneNumber'
import nameValidation from '@/utils/validators/isName'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: "form-edit-crypto-trader",
  components: {
    ContentField
  },
  props: {
    trader: {
      type: Object,
      default: () => ({})
    },
    attendeeTypesList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      traderForm: null,
      assignedPackageId: null,
      cryptoTraderPackagesList: [],
      isPackageChanged: false,
      newChosenPackageId: null
    }
  },
  computed: {
    ...mapGetters ([
      'predefinedActivity',
      'packagesList'
    ]),
    isRegistrationStatusCompleted () {
      return this.traderForm.registrationStatus === "Completed"
    },
    isPendingPackageSelectionStatus () {
      return this.traderForm.registrationStatus === "PendingPackageSelection"
    },
    isPackageData () {
      return path(['package'], this.traderForm)
    },
    traderCreationDate () {
      return moment(this.traderForm.registrationDate).format('LLL')
    },
  },
  watch: {
    trader: {
      handler(val) {
        if(!val) return
        this.traderForm = clone(val)
      },
      immediate: true
    },
    packagesList: {
      handler(val) {
        if(!val) return
        this.cryptoTraderPackagesList = val.filter((packageItem)=> packageItem.type === 'Free')
      },
      immediate: true
    }
  },
  validations: {
    traderForm: {
      firstName: {
        required,
        nameValidation
      },
      lastName: {
        required,
        nameValidation
      },
      email: { required, email },
      phoneNumber: {
        required,
        phoneNumberValidation
      }
    }
  },
  methods: {
    ...mapActions ([
      'getPredefinedActivity',
      'assignCryptoTraderPackage',
      'updateCryptoTrader',
      'updateCryptoTraderPackage',
      'getPackagesList',
      'updateAttendeeSubscription'
    ]),
    close () {
      this.isPackageChanged = false
      this.$bus.$emit('reloadCryptoTraderTable')
      this.$emit('close')
    },
    collectPackagePayload () {
      if (this.isPackageChanged && this.newChosenPackageId) {
        const newPackage = this.cryptoTraderPackagesList.find((packageItem)=> this.newChosenPackageId === packageItem.id)
        return {...newPackage, 'attendeeId': path(['id'], this.traderForm)}
      } else {
        return { ...this.traderForm.package, 'attendeeId': path(['id'], this.traderForm) }
      }
    },
    collectSubscriptionPayload () {
      const subscriptionPayload = {
        'attendeeId': path(['id'], this.traderForm),
        'subscribeToDailyNews': path(['subscribeToDailyNews'], this.traderForm),
        'subscribeToProvidersOffers': path(['subscribeToProvidersOffers'], this.traderForm),
        'subscribeToEventsInfo': path(['subscribeToEventsInfo'], this.traderForm)
      }
      return subscriptionPayload
    },
    async save () {
      this.$v.traderForm.$touch()
      if (this.$v.traderForm.$invalid) return false
      await this.updateCryptoTrader(this.traderForm)
      const subscriptionPayload = this.collectSubscriptionPayload()
      await this.updateAttendeeSubscription(subscriptionPayload)
      if (this.isPendingPackageSelectionStatus && this.assignedPackageId) {
        const payloadData = {
          'packageId': this.assignedPackageId,
          'attendeeId': this.traderForm.id
        }
        await this.assignCryptoTraderPackage(payloadData)
      } else if (this.isRegistrationStatusCompleted) {
        const payloadData = this.collectPackagePayload()
        this.updateCryptoTraderPackage(payloadData)
      }
      this.close()
    },
    async receiveRequiredData () {
      await this.getPredefinedActivity()
      await this.getPackagesList()
    }
  },
  mounted () {
    this.receiveRequiredData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/CryptoTrader/FormEditCryptoTrader.vue